import DeadlineEngineSettingsPage from './DeadlineEngineSettingsPage'

export default function DeadlineCalendarManagementPage() {
  return <DeadlineEngineSettingsPage calendarOnly />
}
